/**
 * V10 Phase C — ⚠️ "이 사건 철회" Modal.
 *
 * Episode 본체 무력화 — 연결된 모든 edge 링크에서 비활성.
 * 카운트다운 3초 · reason 필수.
 */
import { ConfirmCountdownModal } from "./ConfirmCountdownModal.tsx"

type Props = {
	readonly episodeContent: string
	readonly linkedEdgeCount: number
	readonly onClose: () => void
	readonly onConfirm: (reason: string) => Promise<void>
}

export function EpisodeInvalidateModal(props: Props) {
	return (
		<ConfirmCountdownModal
			title="⚠️ 이 사건 철회"
			bodyCopy={`이 사건 (episode) 을 철회합니다. 연결된 ${props.linkedEdgeCount}개 edge 에서 모두 비활성화됩니다. 사건 자체를 부정합니다.\n\n대상: "${props.episodeContent.slice(0, 80)}${props.episodeContent.length > 80 ? "…" : ""}"`}
			countdown={3}
			requireReason={true}
			confirmLabel="사건 철회"
			tone="danger"
			onClose={props.onClose}
			onConfirm={async (reason) => {
				if (!reason) throw new Error("사유는 필수입니다")
				await props.onConfirm(reason)
			}}
		/>
	)
}
